<h2 class="title">{{ 'label.label_configuration' | translate }}</h2>

<div *ngIf="facade.loading$ | async; else settled" class="config-loading" data-cy="label-config-loading">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>

<ng-template #settled>
  <!-- The usage read failed: no checklist can be trusted, so the session collapses
       to the message and a single way out. -->
  <ng-container *ngIf="facade.error$ | async as error; else usage">
    <div class="collapsed" data-cy="label-config-error">
      <i class="ri-error-warning-line collapsed__icon"></i>
      <p class="collapsed__text">{{ error | translate }}</p>
    </div>

    <div class="buttons-row">
      <button type="button" class="btn btn-outline-primary" (click)="onDismiss()" data-cy="label-config-close">
        <i class="ri-close-fill"></i>
        {{ 'button.close' | translate }}
      </button>
    </div>
  </ng-container>

  <ng-template #usage>
    <!-- Nothing uses this label: read-only state, no picker and no submit at all. -->
    <ng-container *ngIf="facade.isEmpty$ | async; else form">
      <div class="collapsed" data-cy="label-config-empty">
        <i class="ri-palette-line collapsed__icon"></i>
        <p class="collapsed__title">{{ 'label_config_editor.empty.title' | translate }}</p>
        <p class="collapsed__text">{{ 'label_config_editor.empty.text' | translate }}</p>
      </div>

      <div class="buttons-row">
        <button type="button" class="btn btn-outline-primary" (click)="onDismiss()" data-cy="label-config-close">
          <i class="ri-close-fill"></i>
          {{ 'button.close' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-template #form>
      <ng-container *ngIf="facade.rows$ | async as rows">
        <ts-color-picker
          class="color-picker"
          [ngModel]="facade.color$ | async"
          (ngModelChange)="onColorPicked($event)"
        ></ts-color-picker>

        <div class="transparency-row">
          <label class="field-label">{{ 'label.transparency' | translate | uppercase }}</label>
          <mat-slider class="transparency-slider" [min]="0" [max]="1" [step]="0.01" discrete>
            <input
              matSliderThumb
              data-cy="label-config-alpha"
              [ngModel]="facade.alpha$ | async"
              (ngModelChange)="onAlphaPicked($event)"
            />
          </mat-slider>
        </div>

        <div class="list-header">
          <label class="select-all">
            <input
              type="checkbox"
              data-cy="label-config-select-all"
              [checked]="(facade.allChecked$ | async) ?? false"
              [indeterminate]="(facade.someChecked$ | async) ?? false"
              (change)="onAllToggled()"
            />
            {{ 'label_config_editor.apply_to_count' | translate : (facade.applyToCountParams$ | async) }}
          </label>
        </div>

        <ul class="rows" data-cy="label-config-rows">
          <li
            *ngFor="let row of rows; trackBy: trackByMethodTypeId"
            [class.checked]="row.checked"
            (click)="onRowToggled(row)"
          >
            <!-- The whole row is the hit target; the checkbox must not toggle twice. -->
            <input
              type="checkbox"
              [checked]="row.checked"
              (click)="$event.stopPropagation()"
              (change)="onRowToggled(row)"
            />
            <ts-method-type-icon class="row-icon" [kind]="row.type"></ts-method-type-icon>
            <span class="name">
              {{ row.name }}
              <em *ngIf="row.pending" class="unsaved-tag" data-cy="label-config-unsaved-tag">
                {{ 'label_config_editor.unsaved' | translate }}
              </em>
            </span>
            <span class="swatches">
              <span
                class="swatch"
                [title]="
                  (row.currentColor ? 'label_config_editor.current_color' : 'label_config_editor.no_color_yet')
                    | translate
                "
              >
                <span class="swatch__fill" [style.background-color]="row.currentColor ?? null"></span>
              </span>

              <ng-container *ngIf="row.checked">
                <i class="ri-arrow-right-line arrow" aria-hidden="true"></i>
                <span class="swatch swatch--new" [title]="'label_config_editor.new_color' | translate">
                  <span class="swatch__fill" [style.background-color]="facade.pickedColor$ | async"></span>
                </span>
              </ng-container>
            </span>
          </li>
        </ul>

        <div class="buttons-row">
          <button type="button" class="btn btn-outline-primary" (click)="onDismiss()" data-cy="label-config-cancel">
            <i class="ri-close-fill"></i>
            {{ 'button.cancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="(facade.canSubmit$ | async) === false"
            (click)="onSubmit()"
            data-cy="label-config-save"
          >
            <i class="ri-save-line"></i>
            {{ 'button.continue' | translate }}
          </button>
        </div>
      </ng-container>
    </ng-template>
  </ng-template>
</ng-template>
